import React from 'react';
import Form from "react-bootstrap/Form";
import {Typeahead} from "react-bootstrap-typeahead";
import ChangeCheckContext from "../support/ChangeCheckContext";

function FreeTypeSelectInput(props) {
    // this component has three main events - onChange, onBlur and onInputChange. When input changes, we need to update
    // state so that typing works correctly. However, this allows state to reach invalid values. Because of this, we use
    // second state, which keeps track of last valid value and if user stops typing without selecting valid value, last
    // valid option is returned back.
    const typeaheadRef = React.useRef(null);
    const [selected, setSelected] = React.useState(props.value)
    const [lastValid, setLastValid] = React.useState(props.value)
    const {disable} = React.useContext(ChangeCheckContext)
    const [isTyping, setIsTyping] = React.useState(false);

    React.useEffect(() => {
        if (!isTyping) {
            setSelected(props.value)
            setLastValid(props.value)
        }
    })

    function handleChange(selection) {
        // Handling change sets current value in the same way as input change, but also updates last valid value if
        // the selected instrument is valid. This ensures that only in the case of valid instruments, change of value will
        // be performed.
        if (selection[0] !== undefined) {
            if (selection[0] !== "") {
                setSelected(selection[0])
                setLastValid(selection[0])
            }
            typeaheadRef.current.blur();
            const event = {target: {name: props.name, value: selection[0]}}
            props.onChange(event)
        }
    }

    function handleInputChange(value) {
        // In order to achieve correct typing, we need to update state on every change.
        setIsTyping(true)
        const newValue = value
        setSelected(newValue)
    }

    function handleBlur(event) {
        if (props.empty) {
            // last, empty instrument section needs to be handled like this, so that the selected value is not applied twice
            setSelected("")
        } else {
            // this returns last valid value if user stops typing without selecting valid value
            setSelected(lastValid)
        }
        setIsTyping(false)
    }

    function getSelected() {
        if (selected !== null) {
            return [selected]
        } else {
            return []
        }
    }

    return (
        <>
            <Form.Group>
                {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
                <div className="mb-3">
                    <Typeahead
                        // inputProps={{
                        //     style: { height: '38px' } // Adjust the height here
                        // }}
                        positionFixed={true}
                        disabled={disable}
                        id="basic-typeahead-single"
                        labelKey={props.labelKey}
                        renderMenuItemChildren={props.renderMenuItemChildren}
                        ref={typeaheadRef}
                        onChange={(selection) => handleChange(selection)}
                        onBlur={handleBlur}
                        options={props.options}
                        placeholder={props.placeholder}
                        selected={getSelected()} //since selected is expecting array, we need to turn value into array
                        onInputChange={handleInputChange}
                    />
                </div>
            </Form.Group>
        </>
    );
};

export default FreeTypeSelectInput;